import { MainStore } from "./MainStore";

export const store = new MainStore();

// @ts-ignore
window.store = store;